
import React, { useState, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from 'react-bootstrap/Dropdown';
import './bulkdiscount.scss'
import UploadCSVModal from "views/Discounts/DiscountCSV/UploadCSVModal";
import DiscountDetailModal from "views/Discounts/DiscountCSV/DiscountDetailModal";
import axios from "axios";
import { Spinner } from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import Environment from "utils/environment";
import { useHistory } from "react-router";
import { Delete } from "@material-ui/icons";
import { Modal } from "react-bootstrap";


const Bulkdiscount = () => {

  const [preview, setPreview] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const history = useHistory()
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [assignshow, setassignShow] = useState(false);
  const [opType, setOpType] = useState("");
  const [assignshow1, setassignShow1] = useState(false);

  const [csvData, setCSVData] = useState([]);
  const val = localStorage.getItem("accessToken");
  const [offset, setOffset] = useState(1);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const api_url = Environment.base_url;
  const url = api_url + "/discounts/csv/";
  const [assignshow2, setassignShow2] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [show1, setShow1] = useState("");

  const getDiscountCSV = async () => {
    try {
      const response = await axios.get('https://api.quick-shop.pk/products/discounts/csv?limit=10&offset=1&search=fileName=&', {
        headers: {
          Authorization: "Bearer " + val,
        },
      });

      if (response.data.data.files) {
        setCSVData(response.data.data.files);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };


  useEffect(() => {
    if (!val) {
      history.push("/");
    } else {
      getDiscountCSV();
    }
  }, []);


  const publishUnpublishDiscountCSV = async (id) => {
    // setLoader(true);
    const config = {
      method: "patch",
      url: api_url + "/discounts/csv/" + id + "/is-publish",
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then((res) => {
        // setLoader(false);
        getDiscountCSV();
      })
      .catch((err) => {
        if (err?.response?.status == 501) {
          history.push("/");
        } else {
          console.log("error meessage: ", err?.response?.data?.message);
          toast.error(err?.response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }
        setLoader(false);
      });
  };


  ///

  const deleteRecord = async (id) => {
    setLoader(true);
    const config = {
      method: "delete",
      url: `${url}${id}`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    await axios(config)
      .then((res) => {
        setLoader(false);
        // setShow1(false);
        // updateList();
      })
      .catch((err) => {
        if (err?.response?.status == 501) {
          history.push("/");
        } else {
          console.log("error meessage: ", err?.response?.data?.message);
          toast.error(err?.response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }
        setLoader(false);
      });
  };
  return (
    <>

      <section className='mainbulkdiscount'>

        <div className="innercatgorydiscount">

          <h1 className="headercoupanmain">
            Bulk Discount CSV
          </h1>
          {/* <button className="innerbtncatgorydiscount">
            Upload CSV
          </button> */}
          <button
            className="innerbtncatgorydiscount"
            onClick={() => {
              setassignShow(true);
              setOpType("add");
            }}
          >
            <img src="" className="img-fluid" alt="" />
            <img
              src="\assestsss\add.svg"
              className="img-fluid"
              alt=""
            />{" "}
            Upload CSV
          </button>
        </div>
        <div className="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">On/Off</th>
                <th scope="col"> Sheet Name</th>
                <th scope="col"> Upload Date</th>
                <th scope="col">Expired On</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {csvData?.length > 0 ? (
                csvData?.map((item, index) => {
                  return (
                    <>


                      <tr>
                        <td>
                          {/* <div className="switch-input">
                            <input
                              class="tgl tgl-ios"
                              id={"toggle1"}
                              type="checkbox"


                            />
                            <label
                              class="tgl-btn"
                              htmlFor="toggle1"
                            ></label>
                          </div> */}
                          <div className="switch-input">
                            <input
                              class="tgl tgl-ios"
                              type="checkbox"
                              id={(index + offset).toString()}
                              defaultChecked={item?.isPublish}
                              onChange={() =>
                                publishUnpublishDiscountCSV(item?.id)
                              }
                            />
                            <label
                              for={(index + offset).toString()}
                              class="tgl-btn"
                            ></label>
                          </div>
                        </td>


                        <td className="innersectd"
                        >
                          {item?.fileName}


                        </td>
                        <td>
                          {moment(item?.createdAt).format(
                            "DD-MMM-YYYY"
                          )}
                        </td>
                        <td>
                          Nov 25, 2021
                        </td>
                        <td>
                          <span className="innerfourthtd"
                            style={{
                              background:
                                item?.isPublish === false ? "#E15151" : "",
                            }}
                          >
                            {/* Published */}
                            {item?.isPublish === true
                              ? "Published"
                              : item?.isPublish === false
                                ? "Unpublished"
                                : ""}
                          </span>
                          {/* <span className="innerfourthtdgreen">
                                            15%
                                        </span> */}
                        </td>
                        <td>
                          {/* <a
                            onClick={() => {
                              setShow(true);


                            }}
                          >
                            <img
                              src="\users-assets\edit-icon.svg"
                              alt="img"
                              className="img-fluid mr-2"
                            />
                          </a> */}
                          <a
                          // onClick={() => {
                          //     setShow1(
                          //         true
                          //     );

                          // }}
                          >
                            {/* <img
                              src="\users-assets\trash-icon.svg"
                              alt="img"
                              className="img-fluid"
                              onClick={() => {
                                setassignShow2(true);
                                setDeleteId(item?.id);
                              }}
                            /> */}
                            <img
                              src="\assestsss\trash.svg"
                              className="img-fluid"
                              alt=""
                              onClick={() => {
                                setDeleteId(item.id);  // set the current item's ID for deletion
                                setShow1(true);

                              }}
                            />
                          </a>
                        </td>















                      </tr>

                    </>
                  );
                })
              ) : loader ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <div className="text-center">
                      {<Spinner animation="border" variant="info" />}
                      {/* <h4>No Categories</h4> */}
                    </div>
                  </td>
                </tr>
              ) : (
                <p>No Records</p>
              )}
              {/* <tr>
                  <td>
                    <div className="switch-input">
                      <input
                        class="tgl tgl-ios"
                        id={"toggle2"}
                        type="checkbox"


                      />
                      <label
                        class="tgl-btn"
                        htmlFor="toggle2"
                      ></label>
                    </div>
                  </td>


                  <td className="innersectd">
                    500RAMZANOFFER.CSV


                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>
                    Nov 25, 2021
                  </td>
                  <td>

                    
                    <span className="innerfourthtdred">
                      Expired
                    </span>
                  </td>
                  <td>
                    <a
                      onClick={() => {
                        setShow(true);


                      }}
                    >
                      <img
                        src="\users-assets\edit-icon.svg"
                        alt="img"
                        className="img-fluid mr-2"
                      />
                    </a>
                    <a
                    
                    >
                      <img
                        src="\users-assets\trash-icon.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </a>
                  </td>















                </tr> */}



            </tbody>
          </table>
        </div>
      </section>
      <UploadCSVModal assignshow={assignshow} setassignShow={setassignShow} />
      <DiscountDetailModal
        assignshow1={assignshow1}
        setassignShow1={setassignShow1}
      />
      {/* <Delete
        show1={assignshow2}
        setShow1={setassignShow2}
        id={deleteId}
        updateList={getDiscountCSV}
        url={url}
      /> */}
      <Modal
        className="modal-password"
        show={show1}
        onHide={() => setShow1(false)}
        centered
      >
        <Modal.Body>
          <div className="del-img">
            <img src="\assestsss\Frame306.svg" className="img-fluid" />
          </div>
          <div className="del-heading">
            <h5>Are You Sure! Want to Delete This Record?</h5>
            <p>
              Do you really want to delete these records? You can't view this in
              your list anymore if you delete!
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="del-footer">
            <button onClick={() => setShow1(false)}>No, Keep it</button>
            <button className="ml-2" 
        onClick={() => deleteRecord(deleteId)} // <-- Pass the deleteId here
            >
              Yes, Delete It
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Offcanvas
        show={show}
        onHide={handleClose}
        className="dicountmainbanner"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Upload CSV</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="bannerss">
            <h4>Upload CSV</h4>
            <div className="item-upload">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <input
                    id="upload"
                    type="file"
                    accept="image/*"
                    className="d-none"
                    onChange={handleImageUpload}
                  />
                  <label htmlFor="upload" className="">
                    {preview ? (
                      <div className='uploadimgprnt'>
                        <img src={preview} alt="Uploaded" className="img-fluid" style={{ maxHeight: '200px' }} />
                      </div>
                    ) : (
                      <div className='uploadimgprnt'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                          <path d="M37.5833 18.6815H32.2849C27.9399 18.6815 24.4016 15.1432 24.4016 10.7982V5.49984C24.4016 4.4915 23.5766 3.6665 22.5683 3.6665H14.7949C9.14825 3.6665 4.58325 7.33317 4.58325 13.8782V30.1215C4.58325 36.6665 9.14825 40.3332 14.7949 40.3332H29.2049C34.8516 40.3332 39.4166 36.6665 39.4166 30.1215V20.5148C39.4166 19.5065 38.5916 18.6815 37.5833 18.6815ZM21.1383 24.8048C20.8633 25.0798 20.5149 25.2082 20.1666 25.2082C19.8183 25.2082 19.4699 25.0798 19.1949 24.8048L17.8749 23.4848V31.1665C17.8749 31.9182 17.2516 32.5415 16.4999 32.5415C15.7483 32.5415 15.1249 31.9182 15.1249 31.1665V23.4848L13.8049 24.8048C13.2733 25.3365 12.3933 25.3365 11.8616 24.8048C11.3299 24.2732 11.3299 23.3932 11.8616 22.8615L15.5283 19.1948C15.6566 19.0848 15.7849 18.9932 15.9316 18.9198C15.9683 18.9015 16.0233 18.8832 16.0599 18.8648C16.1699 18.8282 16.2799 18.8098 16.4083 18.7915C16.4633 18.7915 16.4999 18.7915 16.5549 18.7915C16.7016 18.7915 16.8483 18.8282 16.9949 18.8832C17.0133 18.8832 17.0133 18.8832 17.0316 18.8832C17.1783 18.9382 17.3249 19.0482 17.4349 19.1582C17.4533 19.1765 17.4716 19.1765 17.4716 19.1948L21.1383 22.8615C21.6699 23.3932 21.6699 24.2732 21.1383 24.8048Z" fill="#636363" />
                          <path d="M31.955 16.1516C33.6967 16.1699 36.1167 16.1699 38.1883 16.1699C39.2333 16.1699 39.7833 14.9416 39.05 14.2082C36.41 11.5499 31.68 6.76491 28.9667 4.05157C28.215 3.29991 26.9133 3.81324 26.9133 4.85824V11.2566C26.9133 13.9332 29.1867 16.1516 31.955 16.1516Z" fill="#636363" />
                        </svg>
                        <h4>Drag your file here</h4>

                      </div>
                    )}
                  </label>
                </li>
              </ul>
            </div>


            <div className="buttonss">
              <button className="btn-1" >
                Cancel
              </button>
              <button className="btn-1 btn-2 btnactive" >
                Upload & Save
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

    </>
  )
}

export default Bulkdiscount